import { NetworkError } from './network-error';
import { ApolloError } from 'apollo-client';

class ApolloGraphQLNetworkError extends ApolloError {
  networkError: NetworkError;
}

export const getNetworkError = (
  error?: ApolloGraphQLNetworkError,
): NetworkError | null => {
  if (
    error?.networkError?.code !== undefined &&
    error?.networkError?.message !== undefined &&
    error?.networkError?.status !== undefined
  ) {
    const { code, message, status } = error.networkError;
    return new NetworkError(message, { code, status });
  }
  return null;
};
